import { newToolFilterOAuthMcp } from "../oauth.ts";

export const otterMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://cdn.prod.website-files.com/618e9316785b3582a5178502/618e943a80919a98b5e9bf69_apple-icon.png",
  url: "https://mcp.otter.ai/mcp",
  label: "Otter.ai",
});
